import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faFacebookF, faXTwitter, faYoutube, faTiktok, faStrava } from '@fortawesome/free-brands-svg-icons'

library.add(faSearch, faInstagram, faFacebookF, faXTwitter, faYoutube, faTiktok, faStrava)
dom.watch() // replaces <i class="fab fa-..."> with inline SVGs